import RichTextElementMetaData from './RichTextElementMetaData';

const presets = [
  {
    type: RichTextElementMetaData.type,
    layout: {
      x: 0,
      y: 0,
      width: 400,
      height: 96
    },
    compProps: {
      fontSize: 14,
      color: 'rgb(83, 83, 83)',
      zIndex: 1,
      fontFamily: 'Open Sans', // prevent inheriting Ariel from old templates.
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    data: {
      compProps: {
        fontSize: 14,
      },
      rawHTML: `<p>I'm a paragraph. Simply double click here to add your own text and edit me. It's easy. Describe your product. Mention details and specifications that you believe are relevant to your buyers.</p>`,
      fontSizeInPercentFromDesktop: 100,
    },
    hidden: false
  }
];

export default presets;
